import { css } from '@repo/pandacss/styled-system/css';
import { renderStructuredContent } from '../../rendererContext';
import type { AccordionProps } from './types';

export function Accordion({ props: { children, rendererProps } }: AccordionProps) {
  return (
    <ul
      className={css({
        paddingTop: '0',
        paddingRight: '0',
        paddingBottom: '0',
        paddingLeft: '0',
        marginTop: '0',
        marginRight: '0',
        marginBottom: '0',
        marginLeft: '0',
        listStyleType: 'none',
      })}
      data-testid="accordion"
    >
      {renderStructuredContent(children, rendererProps)}
    </ul>
  );
}
